import { observer } from "mobx-react-lite";
import * as React from "react";
import { DrawerPlmWithConfirmation } from "src/components/DrawerPlmWithConfirmation";
import { EntityFiltersPageStore } from "src/pages/EntityFiltersPage/EntityFiltersPageStore";
import { EntityFiltersTable } from "src/pages/EntityFiltersPage/EntityFiltersTable";
import { ZEntityRow } from "src/pages/EntityFiltersPage/EntityList/types";

type PropsBom3MaterialModal = {
  store: EntityFiltersPageStore | null;
  close: () => void;
  success: (selected: ZEntityRow) => void; // без закрывания
};

export const Bom3MaterialModal: React.FC<PropsBom3MaterialModal> = observer(
  (props) => {
    const { store, close, success } = props;
    const tableStore = store?.tableStore;
    const selected = tableStore?.selected?.[0];
    const title = store?.title ?? "Выбор материала";

    return (
      <DrawerPlmWithConfirmation
        drawerProps={{
          title,
          open: !!store,
          onClose: close,
          width: "75vw",
          styles: {
            body: {
              display: "flex",
            },
          },
        }}
        confirmationProps={{
          okText: "Выбрать",
          okButtonProps: {
            disabled: !selected,
            onClick: () => {
              if (selected) {
                success(selected);
                close();
              }
            },
          },
          cancelButtonProps: {
            onClick: close,
          },
        }}
      >
        {store && <EntityFiltersTable store={store} />}
      </DrawerPlmWithConfirmation>
    );
  },
);
